import { createSelector } from 'reselect';
import { ProductGroupModel } from '@/typings/models/ProductGroup';

const selectProductGroupsState = (state: DefaultRootState) => state.productGroups;

export const selectProductGroups = createSelector(
  [selectProductGroupsState],
  (productGroups) => productGroups
);

export const selectProductGroupList = createSelector(
  selectProductGroupsState,
  (productGroups): ProductGroupModel[] => productGroups?.productGroupList || []
);

export const selectProductGroupById = createSelector(
  [selectProductGroupList, (_, productGroupId: string) => productGroupId],
  (productGroupList, productGroupId) =>
    productGroupList.find((pg) => pg.uuid === productGroupId)
);

export const selectProductGroupDrawer = createSelector(
  [selectProductGroupsState],
  (productGroups) => productGroups?.productGroupDrawer
);
